import { createClient } from '@supabase/supabase-js';

import { clientEnvironment } from '../config/client-env';
import type { Database } from '../types/database.generated';

export const hasSupabaseClient = Boolean(
  clientEnvironment.VITE_SUPABASE_URL && clientEnvironment.VITE_SUPABASE_PUBLISHABLE_KEY,
);

// Le schéma Postgres de la V2 est `alba`, distinct du schéma `public` de la V1.
export const supabase = hasSupabaseClient
  ? createClient<Database, 'alba'>(
      clientEnvironment.VITE_SUPABASE_URL as string,
      clientEnvironment.VITE_SUPABASE_PUBLISHABLE_KEY as string,
      { db: { schema: 'alba' } },
    )
  : null;
